module.exports = __webpack_public_path__ + "static/media/fac9.83d4554d.jpg";